import React from 'react'
import { TableHeaderFont, TableHorizontalAlignment, TableVerticalAlignment } from '@lib/types/component-table'
import { pxToRem } from '@lib/utils/css'
import { horizontalAlignMap, verticalAlignMap } from './utils'
import styles from './table-cell.module.scss'

export interface TableHeaderCellProps {
  children: React.ReactNode
  config?: TableHeaderCellConfig
}

export interface TableHeaderCellConfig {
  font: TableHeaderFont
  verticalAlignment: TableVerticalAlignment
  horizontalAlignment: TableHorizontalAlignment
}

const headerFontSizeMap: Record<TableHeaderFont, [string, string]> = {
  [TableHeaderFont.HeadingXLarge]: [pxToRem(28), pxToRem(32)],
  [TableHeaderFont.HeadingLarge]: [pxToRem(24), pxToRem(26)],
  [TableHeaderFont.HeadingMedium]: [pxToRem(20), pxToRem(22)],
  [TableHeaderFont.SubheadingLarge]: [pxToRem(24), pxToRem(28)],
  [TableHeaderFont.SubheadingMedium]: [pxToRem(20), pxToRem(22)],
  [TableHeaderFont.SubheadingSmall]: [pxToRem(16), pxToRem(18)],
}

export const TableHeaderCell: React.FC<TableHeaderCellProps> = ({ children, config }) => {
  const {
    font = TableHeaderFont.HeadingMedium,
    verticalAlignment = TableVerticalAlignment.Top,
    horizontalAlignment = TableHorizontalAlignment.Left,
  } = config ?? {}
  return (
    <th
      className={styles.cell}
      style={{
        verticalAlign: verticalAlignMap[verticalAlignment],
        textAlign: horizontalAlignMap[horizontalAlignment],
        fontSize: headerFontSizeMap[font][0],
        lineHeight: headerFontSizeMap[font][1],
      }}
    >
      {children}
    </th>
  )
}
